export default "__VITE_ASSET__BUfAZY9J__"